import { Tba } from '../tba';
import { TbaRangeResult } from '../tba-range-result';
import { MethodEvaluation } from '../method-evaluation';

export class TbaMethodEvaluationResponse {
  tba: Tba;
  rangeResults: TbaRangeResult[];
  methodEvaluation: MethodEvaluation;
  srcDiscussionCollapsed?: boolean;
  destDiscussionCollapsed?: boolean;
}
